import * as React from 'react';

import { Button, type ButtonProps } from '../button';

export type OpenInNewTabLinkButtonProps = Omit<
  ButtonProps,
  'asChild' | 'onClick' | 'type'
> & {
  href: string;
  /** Describe the destination; required when the control is icon-only. */
  'aria-label': string;
};

/**
 * Icon or text button that navigates in a new browser tab (`target="_blank"`).
 * Use for cross-route or cross-app links where a plain in-app router link is not enough.
 */
export const OpenInNewTabLinkButton = React.forwardRef<
  HTMLAnchorElement,
  OpenInNewTabLinkButtonProps
>(function OpenInNewTabLinkButton(
  { href, children, 'aria-label': ariaLabel, ...buttonProps },
  ref,
) {
  return (
    <Button asChild {...buttonProps}>
      <a
        ref={ref}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
      >
        {children}
      </a>
    </Button>
  );
});

OpenInNewTabLinkButton.displayName = 'OpenInNewTabLinkButton';
